<template>
  <div
    v-if="$store.getters.isRtbFlowPossible && data && (data.perHour || data.perDay)"
    class="mb-4"
  >
    <div class="flex flex-wrap justify-around text-base">
      <div v-if="data.perHour" class="mx-2 pb-2">
        <template v-if="data.perHour.hasOther">
          from
        </template>
        <span class="text-2xl font-semibold">{{ data.perHour.price.formatted }}</span> / hour
      </div>
      <div v-if="data.perDay" class="mx-2 pb-2">
        <template v-if="data.perDay.hasOther">
          from
        </template>
        <span class="text-2xl font-semibold">{{ data.perDay.price.formatted }}</span> / day
      </div>
    </div>
    <div
      v-if="$store.state.room.minHoursForBooking && $store.state.room.minHoursForBooking > 1"
      class="text-center text-grey-600 text-sm"
    >
      <span v-if="showFullDayRateOnly">Full day rate only</span>
      <span v-else>Minimum {{ $store.state.room.minHoursForBooking }} hours</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'EnquiryPricingBar',
  computed: {
    ...mapState([
      'minimumPricing',
      'roomSetupAllowsOP',
    ]),
    data() {
      return this.$store.state.minimumPricing;
    },
    showFullDayRateOnly() {
      return this.$store.getters.isRtbFlowPossible && this.data?.perDay && !this.data?.perHour;
    },
  },
  watch: {
    data: {
      handler() {
        if (this.showFullDayRateOnly) {
          const minimumBookingDurationElement = document.querySelector('.js-prices-minimum-booking-duration');

          if (minimumBookingDurationElement) {
            minimumBookingDurationElement.style.display = 'none';
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
